<template>
    <audio class="mt-10 w-full" :src="src" controls ref="player"></audio>
</template>

<script>
import Plyr from "plyr";
import "plyr/dist/plyr.css";

export default {
    name: "DdAudioPlayer",
    props: {
        src: {
            type: String,
            default: ""
        },
        startAt: {
            type: Number,
            default: 0
        }
    },
    mounted() {
        const player = new Plyr(this.$refs.player);
        player.once("loadeddata", () => {
            player.currentTime = this.startAt;
        });
    }
};
</script>